import { render } from "./VariantList.vue?vue&type=template&id=488b88bc"
import script from "./VariantList.vue?vue&type=script&lang=js"
export * from "./VariantList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__